module.exports = __webpack_public_path__ + "img/personal-web01.8c1360bd.png";